import React from 'react';
import { useSelector } from 'react-redux';

import SmartLink from 'dpl/components/SmartLink';
import { BREED_HEALTH_TESTING_GUIDE_PATH } from 'dpl/shared/constants/urls';

import BreedOverviewSectionContent from './BreedOverviewSectionContent';

export default function BreedHealthSectionContent() {
  const { overviewPageData, breedData } = useSelector(({ server }) => server);

  return (
    <div className="BreedHealthSectionContent">
      <BreedOverviewSectionContent
        subheader={overviewPageData.health_intro.title}
        content={
          <>
            <p className="mb4">
              Lifespan: {breedData.life_span_low} to {breedData.life_span_high}{' '}
              years.
            </p>
            <p>{overviewPageData.health_intro.long_description}</p>
          </>
        }
      />
      <div className="row mt4 mt12-md">
        {overviewPageData.health_issues.map((issue, idx) => (
          <div key={idx} className="col-12 col-md-6">
            <div className="font-16-mobile f3-md mb6">
              <p className="fw-medium mb2">{issue.name}</p>
              <p>{issue.description}</p>
            </div>
          </div>
        ))}
      </div>
      <SmartLink
        to={`/breeds/${breedData.breed_slug}${BREED_HEALTH_TESTING_GUIDE_PATH}`}
        className="font-16-mobile f3-md fw-medium stone-700 dib mt2-md"
        target="_blank"
      >
        Learn more about health issues that may impact{' '}
        {breedData.pluralized_name}
      </SmartLink>
    </div>
  );
}
